import { UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem } from '@common/product-card';
import { PDPGoodsGroup, VerticalProductCardCarouselContainer } from '@domains/pdp-common';

import {
  convertProductCardItemsToUxGoodsCardItem,
  getRanking,
  isShowRanking,
} from '../../utils/convertProductCardItem';
import { CarouselTitle } from '../CarouselTitle';
import { LayoutWithMoreButton } from '../LayoutWithMoreButton';

export type listInfoConfig = {
  groupType: string;
  mainTitle?: string;
  position: number;
};

interface RelatedRecommendCarouselsProps {
  lists: PDPGoodsGroup[];
  onClickMore?: () => void;
  onImpressionProduct: (listInfo: listInfoConfig) => (item: UxGoodsCardItem) => void;
  onClickProduct: (listInfo: listInfoConfig) => (item: UxGoodsCardItem) => void;
  onSaveProduct: (listInfo: listInfoConfig) => (checked: boolean, item: UxGoodsCardItem) => void;
}

export const RelatedRecommendCarousels = ({
  lists,
  onClickMore,
  onImpressionProduct,
  onClickProduct,
  onSaveProduct,
}: RelatedRecommendCarouselsProps) => {
  return (
    <>
      {lists.map((list) => {
        const items = list.goods_carousel.component_list.map((item, index) =>
          convertProductCardItemsToUxGoodsCardItem(item, getRanking(isShowRanking(list.group_type), index)),
        );

        return (
          <LayoutWithMoreButton
            key={list.main_title.text}
            button={
              list.more_button ? { text: list.more_button?.text, landingUrl: list.more_button?.link_url } : undefined
            }
            onClickMore={onClickMore}
          >
            <VerticalProductCardCarouselContainer
              title={<CarouselTitle title={list.main_title.text} isAd={list.is_ad} />}
              items={items}
              defaultSize='small'
              onClick={(item, index) =>
                onClickProduct({
                  groupType: list.group_type,
                  mainTitle: list.main_title.text,
                  position: index,
                })(item)
              }
              onLikeClick={(isLiked, item, index) =>
                onSaveProduct({
                  groupType: list.group_type,
                  mainTitle: list.main_title.text,
                  position: index,
                })(isLiked, item)
              }
              onImpression={(item, index) =>
                onImpressionProduct({
                  groupType: list.group_type,
                  mainTitle: list.main_title.text,
                  position: index,
                })(item)
              }
            />
          </LayoutWithMoreButton>
        );
      })}
    </>
  );
};
